export default __webpack_public_path__ + "static/media/notepad-green.79aaee95.png";